// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography, Grid, Box } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
// Components
import GoTable from "../../common/GoTable/GoTable";
// Constants
import { DAILY_FEE_COLLECTIONS_TABLE_HEADS } from "../../configs/TableHeaderConstants";
import EntityConstants from "../../configs/EntityConstants";
import PermissionConstants from "../../configs/PermissionConstants";
// Services
import { get, del, gen_link, post } from "../../services/FetchHelper";
import SpinService from "../../services/SpinService";
// Hooks
import usePermissions from "../../hooks/usePermissions";
// Utils
import { dailyFeeCollectionConfig } from "./Reports.utils";
//Third party
import { Form, Formik } from "formik";
import GoForm from "../../components/Inputs/GoForm";
// Styles
import { styled } from "@mui/material/styles";

const StyledRoot = styled("div")(({ theme }) => ({
    // minHeight: 96,
    width: "100%",
    display: "block",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2, 2, 2),
    paddingBottom: '10px'
}));

const DailyFeeCollections = () => {
    const navigate = useNavigate();
    const permissions = usePermissions();
    const spinService = SpinService();
    const [formFields, setFormFields] = useState(dailyFeeCollectionConfig.formFields);
    const [dailyFeeCollections, setDailyFeeCollections] = useState([]);
    const [dependencies, setDependencies] = useState({
        schools: [],
        mode_of_pays: [],
    });

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleSubmit = async (values) => {
        // spinService.on();
        const response = await post(EntityConstants.DAILY_FEE_COLLECTIONS, values);
        const data = await response.json();
        setDailyFeeCollections(data);
        spinService.off();
    }

    const downloadHandle = (values) => {
        const link = document.createElement('a');
        link.href = gen_link(EntityConstants.DAILY_FEE_COLLECTIONS_DOWNLOAD, `filter=${JSON.stringify(values)}`);
        link.target = '_blank';
        link.click();
    };

    useEffect(() => {
        const fetchSchoolsAndModeOfPays = async () => {
            let requests = [
                get(EntityConstants.SCHOOLSBYCOMPANIES),
                get(EntityConstants.MODE_OF_PAYES, `max=all`),

            ]
            const responses = await Promise.all(requests);
            const [schools, mode_of_pays] = await Promise.all(responses.map(response => response.json()));
            setDependencies((prevState) => {
                return {
                    ...prevState,
                    schools: schools,
                    mode_of_pays: [{ description: "ALL", id: -1, mode_of_pay: "All", status: true }, ...mode_of_pays],
                }
            });
        };
        if (permissions.has(PermissionConstants.DAILY_FEE_REPORT)) {
            fetchSchoolsAndModeOfPays();
        } else {
            navigate("/")
        }
    }, []);

    useEffect(() => {
        if (dependencies.schools.length > 0) {
            attachOptions("school_id", dependencies.schools)
        }
    }, [dependencies.schools]);

    useEffect(() => {
        if (dependencies.mode_of_pays.length > 0) {
            attachOptions("mode_of_pays", dependencies.mode_of_pays)
        }
    }, [dependencies.mode_of_pays]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        DAILY FEE COLLECTIONS
                    </Typography>
                </Stack>
                <Card>
                    <StyledRoot>
                        <Formik
                            enableReinitialize
                            initialValues={dailyFeeCollectionConfig.state}
                            validationSchema={dailyFeeCollectionConfig.schema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({
                                values,
                                touched,
                                errors,
                                handleChange,
                                handleSubmit,
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        alignItems="center"  // Vertical alignment
                                        rowSpacing={1}
                                        columnSpacing={1}
                                        style={{ margin: "0 auto" }}
                                    >
                                        {formFields.map((formField, index) => (
                                            <Grid key={index} item xs={12} sm={12} md={3} lg={3}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        ))}
                                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: "flex", justifyContent: "end" }}>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Iconify icon="eva:save-fill" />}
                                                    type="submit"
                                                >
                                                    Filter
                                                </Button>
                                            </Box>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    disabled={dailyFeeCollections.length === 0}
                                                    variant="contained"
                                                    startIcon={<Iconify icon="typcn:download" />}
                                                    onClick={() => downloadHandle(values)}
                                                >
                                                    Download
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </StyledRoot>
                </Card>
                <Card>
                    <GoTable
                        tableHeads={DAILY_FEE_COLLECTIONS_TABLE_HEADS}
                        tableDatas={dailyFeeCollections}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            </Container>

        </React.Fragment>
    );
};

export default DailyFeeCollections;